import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ChartFunctionService} from '@app/layout/charts/chart-functions/chart-function-service';
import {Period, TimePeriod} from '@app/layout/charts/chart-functions/time-period';
import {FunctionParamsAndChartRawValues} from '../equipment-group.component';
import {Orientation, ReferenceLine} from '../../reference-line';
import {ChartFunction, FunctionName} from '@app/layout/charts/chart-functions/chart-function-types';
import {AceLoggerService} from '@logging/ace-logger.service';
import {AceLogger} from '@logging/ace-logger';

@Component({
  selector: 'app-select-function-modal',
  templateUrl: './select-function-modal.component.html',
  styleUrls: ['./select-function-modal.component.scss'],
  standalone: false
})
export class SelectFunctionModalComponent implements OnInit {

  // note: currently only handles 1 FunctionParam
  @Input() functionParamsAndChartRawValues: FunctionParamsAndChartRawValues;
  @Input() referenceLines: ReferenceLine[];

  readonly NONE_FUNCTION: ChartFunction = {name: FunctionName.NONE, longNameKey: 'None', run: (_) => []};
  readonly periods: TimePeriod[] = [new TimePeriod(Period.MINUTES, 15), new TimePeriod(Period.MINUTES, 30),
    new TimePeriod(Period.HOURS, 1), new TimePeriod(Period.HOURS, 12), new TimePeriod(Period.DAYS, 1),
    new TimePeriod(Period.WEEKS, 1), new TimePeriod(Period.MONTHS, 1)];
  readonly chartFunctions: ChartFunction[];
  chosenFunctionName: FunctionName;
  chosenTimePeriod: TimePeriod;
  chosenChartRawValues: boolean;
  showTimePeriod: boolean;

  private readonly timePeriodFunctionNames: Set<FunctionName> = new Set([FunctionName.AVG, FunctionName.MIN, FunctionName.MAX, FunctionName.SUM]);
  private readonly logger: AceLogger;

  constructor(public activeModal: NgbActiveModal,
              chartFunctionService: ChartFunctionService,
              logService: AceLoggerService) {
    this.chartFunctions = [...chartFunctionService.getAllFunctions()];
    this.logger = logService.create(SelectFunctionModalComponent.name);
  }

  ngOnInit() {
    if (this.referenceLines && this.referenceLines.some(r => r.getOrientation() === Orientation.Vertical)) {
      this.periods.push(new TimePeriod(Period.REFERENCE_LINES));
    }

    if (!this.functionParamsAndChartRawValues || !this.functionParamsAndChartRawValues.functionParams || !this.functionParamsAndChartRawValues.functionParams.length) {
      this.chosenFunctionName = FunctionName.NONE;
      this.chosenTimePeriod = null;
      this.showTimePeriod = false;
      this.chosenChartRawValues = true;
    } else {
      this.chosenFunctionName = this.functionParamsAndChartRawValues.functionParams[0].functionName;
      this.showTimePeriod = this.timePeriodFunctionNames.has(this.chosenFunctionName);
      const timePeriod = this.functionParamsAndChartRawValues.functionParams[0].timePeriod;
      if (timePeriod) {
        this.chosenTimePeriod = this.periods.find(p => timePeriod.isEqual(p));
      } else if (this.showTimePeriod) {
        this.logger.error('Function ' + this.chosenFunctionName + ' requires a time period but it is not set');
      }
      this.chosenChartRawValues = this.functionParamsAndChartRawValues.chartRawValues;
    }
  }

  onSubmit() {
    const value: FunctionParamsAndChartRawValues = this.chosenFunctionName === FunctionName.NONE ? {functionParams: [], chartRawValues: false} : {
      functionParams: [{functionName: this.chosenFunctionName, timePeriod: this.timePeriodFunctionNames.has(this.chosenFunctionName) ? this.chosenTimePeriod : null}],
      chartRawValues: this.chosenChartRawValues
    };

    this.activeModal.close(value);
  }

  functionChange(functionName: FunctionName) {
    this.showTimePeriod = this.timePeriodFunctionNames.has(functionName);
  }

  isPeriodSelected(): boolean {
    return !this.showTimePeriod || this.periods.some(p => p.isEqual(this.chosenTimePeriod));
  }
}
